import React, { Component } from "react";
import {
  showUserSignInModal as showUserSignInModalAction,
  hideUserSignInModal as hideUserSignInModalAction,
} from "../../actions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isLoggedInUser } from "../../util/selectors";
import PublishSuccessBanner from "../../components/PublishSuccessBanner";
import Transition from "react-transition-group/Transition";
import { clearCurrentPost, loadCurrentPostBySlugRequest, loadCurrentPostByIdRequest } from "../../actions/postActions";
import PostDetailedContent from "./PostDetailedContent";

class PostDetailed extends Component {
  constructor(props) {
    super(props);
    // TODO: use error
    this.state = {
      error: false,
    };
  }

  componentDidMount() {
    this.loadCurrentPost(this.props.currentRoute.params);
  }

  componentWillReceiveProps(nextProps) {
    const isURLChange = nextProps.currentRoute.pathname !== this.props.currentRoute.pathname;
    if (isURLChange) {
      this.props.actions.clearCurrentPost();
      this.loadCurrentPost(nextProps.currentRoute.params);
    }
  }

  componentWillUnmount() {
    this.props.actions.hideUserSignInModal();
    this.props.actions.clearCurrentPost();
  }

  componentWillUpdate(nextProps, nextState) {
    // NOTE: this code needs refactoring
    if (this.props.user.profile === null && !this.props.user.isSignInModalOpen) {
      sessionStorage.setItem("storeLastRoute", this.props.currRoutePath);
      this.props.actions.showUserSignInModal();
    }
  }

  render() {
    const { post } = this.props;
    // TODO: handle error message (if this.state.error === true)
    return (
      <div>
        <Transition
          timeout={{
            enter: 500,
            exit: 500,
          }}
          in={post._id && post.isJustPublished}
          unmountOnExit={false}
        >
          {status => <PublishSuccessBanner post={post} animationClass={`banner-${status}`} />}
        </Transition>

        <Transition
          timeout={{
            enter: 500,
            exit: 500,
          }}
          in={post._id && post.isJustPublished}
          unmountOnExit={false}
        >
          {status => (
            <div>
              <PostDetailedContent
                recommendedPostsAnimationClass={`recommended-posts-${status}`}
                animationClass={`individual-post-${status}`}
                {...this.props}
              />
            </div>
          )}
        </Transition>
      </div>
    );
  }

  loadCurrentPost(params) {
    const { id, slug } = params;
    if (slug) {
      this.props.actions.loadPostBySlug(slug);
    } else if (id) {
      this.props.actions.loadPostById(id);
    } else {
      this.setState({ error: true });
      console.error("error ", this.props.currentRoute.params);
    }
  }
}

PostDetailed.propTypes = {
  post: PropTypes.object,
  currentRoute: PropTypes.object.isRequired,
  likePost: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user,
    currentRoute: state.router,
    isAuthorized: isLoggedInUser(state),
    post: state.posts.current,
    currRoutePath: state.router.pathname,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadPostBySlug: slug => {
        dispatch(loadCurrentPostBySlugRequest(slug));
      },
      loadPostById: id => {
        dispatch(loadCurrentPostByIdRequest(id));
      },
      showUserSignInModal: () => {
        dispatch(showUserSignInModalAction());
      },
      hideUserSignInModal: () => {
        dispatch(hideUserSignInModalAction());
      },
      clearCurrentPost: () => {
        dispatch(clearCurrentPost());
      },
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostDetailed);



// WEBPACK FOOTER //
// ./src/scenes/PostDetailed/index.js